<template>
  <TeamTaskTest />
</template>

<script>
import TeamTaskTest from "../../components/teamtaskTest";
export default {
  components: {
    TeamTaskTest,
  },
};
</script>

